let storeRef = null;

export const injectStore = (store) => {
  storeRef = store;
};

export const getStore = () => {
  if (!storeRef) {
    throw new Error('Redux store has not been injected yet');
  }
  return storeRef;
};

export const runQuery = async (endpoint, arg, options = { forceRefetch: true }) =>
  getStore().dispatch(endpoint.initiate(arg, options)).unwrap();

export const runMutation = async (endpoint, arg) =>
  getStore().dispatch(endpoint.initiate(arg)).unwrap();
